// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userful-options-wrapper{display:flex;align-items:flex-start;gap:8px}`, "",{"version":3,"sources":["webpack://./src/inputs/option/OptionInput.scss"],"names":[],"mappings":"AAAA,yBACI,YAAA,CACA,sBAAA,CACA,OAAA","sourcesContent":[".userful-options-wrapper {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
